import { base64Converter } from './converter/base64-converter'
import logger from './log-utils'
/**
 JWT 관련 유틸리티
 @packageDocumentation
 */

/**
 * 토큰의 클레임을 조회한다.
 * @param token
 */
export const getClaim = (token: string) => {
  try {
    if (!token) {
      return null
    }
    const claim = token.split('.')[1]
    return JSON.parse(base64Converter.deConvert(claim))
  } catch (e) {
    logger().error('invalid token', token, e)
    return null
  }
}
